import { createFeatureSelector, createSelector } from "@ngrx/store";
import { OrderState } from "./order.reducer";

export const selectOrderState = createFeatureSelector<OrderState>('order');

// Removed selectGetOrders; frontend uses gateway-backed data only
export const selectGetOrders = createSelector(
  selectOrderState,
  (state) => state.orders
);

export const selectGetPendingOrders = createSelector(
  selectOrderState,
  (state) => state.pendingOrders
);

export const selectGetReflexOrders = createSelector(
  selectOrderState,
  (state) => state.reflexOrders
)

export const selectCurrentOrder = createSelector(
  selectOrderState,
  (state) => state.selectedOrder
)

export const selectCurrentReflexOrder = createSelector(
  selectOrderState,
  (state) => state.selectedReflexOrder
)
